import React from 'react'
import { LargeButton, Button, Title, Wrapper } from './styled'

const StyledComponent = () => (
  <Wrapper>
    <Title>{'Main Title!'}</Title>
    <Button textColor="red" backgroundColor="white">
      Button
    </Button>
    <LargeButton>Large Button</LargeButton>
    <LargeButton as="a" href="#">
      Button as a href
    </LargeButton>
  </Wrapper>
)

export default StyledComponent
